<template>
	<div class="list-item">
		<div class="libox">
			<div class="libox-l">
				<div class="t">{{ itemData.policyName }}</div>
				<div class="policylabel">
					<span class="yellow" v-if="itemData.lastDays > 0">剩余{{itemData.lastDays}}天</span>
					<!--<span class="yellow" v-else>已过期</span>-->
					<span class="green">{{itemData.department}}</span>
				</div>
				<div class="time">申报时间：
					<span v-if="itemData.startDate || itemData.endDate">{{itemData.startDate}}{{ itemData.startDate&&itemData.endDate ? '～' : '' }}{{itemData.endDate}}</span>
					<span v-else>待定</span>
				</div>
			</div>
			<div class="libox-r">
				<!--<p class="scores">匹配度<span>{{itemData.matchScore}}分</span></p>-->
				<div class="apply-price">
					<p v-if="itemData.policyTypeId === 2" class="lab">最高可减免</p>
					<p v-else class="lab">最高可申报</p>
					<p class="price"><span>{{itemData.maxSubsidy}}</span>{{itemData.maxSubsidyUnit}}</p>
				</div>
			</div>
			<span class="tip" v-if="!itemData.isRead"></span>
		</div>
	</div>


</template>

<script>
	export default {
		name: 'ListItem',
		props:{
			itemData:{
				type: Object,
				default:()=>{
					return {}
				}
			}
		}
	};
</script>

<style scoped lang="less">
	.list-item{
		.libox {
			padding: 16px;
			box-shadow: 0px 0px 20px 0px rgba(0, 0, 0, 0.05);
			border-radius: 5px;
			margin-bottom: 16px;
			position: relative;
			display: flex;
			.tip {
				display: inline-block;
				position: absolute;
				top: 5px;
				left: 5px;
				width: 10px;
				height: 10px;
				background: #FA5151;
				border: 1px solid rgba(255, 255, 255, 1);
				border-radius: 50%;
			}
			.libox-l {
				flex: 1;
			}
			.libox-r {
				width: 90px;
				display: flex;
				justify-content: space-around;
				flex-direction: column;
				text-align: center;
				.apply-price {
					background: rgba(255, 255, 255, 1);
					box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.05);
					border-radius: 4px;
				}
			}
			.t {
				font-size: 16px;
				font-weight: bold;
				color: #333;
				line-height: 22px;
				.overflowhide(2);
			}
			.time {
				font-size: 12px;
				color: @blue;
				margin-top: 15px;
			}
			.gray {
				color: #999999;
			}
			.libox-r {
				.scores {
					font-size: 12px; line-height: 18px; color: #999;
					span { color: @yellow;}
				}
				.lab {
					line-height: 22px;
					background: rgba(235, 243, 255, 1);
					border-radius: 4px 4px 0px 0px;
					margin: 0 0 12px 0px;
					font-size: 12px;
					color: @blue;
					padding: 0 10px;
				}
				.price {
					font-size: 12px; color: @priceColor;
					font-family: DINCondensedBold;
					span { font-size: 24px; }
				}
			}
			.iconfont {
				position: absolute;
				font-size: 12px;
				top: 50%;
				margin-top: -6px;
				right: 16px;
				color: #ccc;
			}
		}
	}
</style>
